// @ts-ignore
export async function genericFetcher<T>(
  input: RequestInfo | URL,
  init?: RequestInit
): Promise<T> {
  const res = await fetch(input, init);
  return await res.json();
}

export function fetcherFactory<T>(
  init?: RequestInit
) {
  async function generatedFetcher<T>(
    input: RequestInfo | URL
  ): Promise<T> {
    return await genericFetcher(input, init);
  }

  return generatedFetcher;
}